import { useEffect, useState } from "react";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, getNodeRootStyleAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeType } from "../EditorTypes";
import { gridAttributes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { clear } from "console";
import WebDesigner from "../WebDesigner";

const gridAtt = "gridArea";


export type GridAreaData = {
    yStart: number;
    yEnd: number;
    xStart: number;
    xEnd: number;

    width: number,
    height: number;
}

type GridColRowData = {
    rowCount: number;
    columnCount: number;

}

export type GridRenderData = {
    colCount: number;
    rowCount: number;
    // cellWidth: number;
    // cellHeight: number;
    // bounds: DOMRect;
    gapX: number;
    gapY: number;
    ratio:number;

}



export function GetGridAreaDataFromStr(str: string): GridAreaData {

    let split = str.split("/");

    let yStart = parseInt(split[0]) ?? 1;
    let xStart = parseInt(split[1]) ?? 1;
    let yEnd = parseInt(split[2]) ?? 6;
    let xEnd = parseInt(split[3]) ?? 6;

    return {
        yStart,
        xStart,
        yEnd,
        xEnd,
        width: xEnd - (xStart),
        height: yEnd - (yStart)
    }


}
export function GetGridAreaDataFromNode(node: AttributeCollection, screenSIze: ScreenSize): GridAreaData {

    let str = getNodeRootStyleAttributeValue(node, screenSIze, gridAtt, "1/1/6/6");

    return GetGridAreaDataFromStr(str);

}

export const GetCountFromGridRepeatString = (str: string) => {

    let index = str.indexOf("repeat(");
    let indexTwo = str.indexOf(",", index);
    let newStr = str.substring(index + 7, indexTwo);
    let count = parseInt(newStr);
    if (isNaN(count)) {
        count = 4;
    }
    return count;
}

export const defualtGridSizing = {
    rowCount: 10,
    columnCount: 20,

}

export function GetGridColumnRowsFromNode(node: LayoutNode, screenSIze: ScreenSize): GridColRowData {

    // if(screenSIze == ScreenSize.Mobile){
    //     defaultRows = defaultRows*2;
    //     defaultColumns = defaultColumns/2;
    // }

    let rows = getNodeRootStyleAttributeValue(node, screenSIze, "gridTemplateRows", `repeat(${defualtGridSizing.rowCount},1fr)`);
    let columns = getNodeRootStyleAttributeValue(node, screenSIze, "gridTemplateColumns", `repeat(${defualtGridSizing.columnCount},1fr)`);

    let rowCount = GetCountFromGridRepeatString(rows);
    let columnCount = GetCountFromGridRepeatString(columns);

    return {
        rowCount,
        columnCount
    }

}

export function GetGridRenderData(node: LayoutNode, screenSize: ScreenSize): GridRenderData {

    let gridColRow = GetGridColumnRowsFromNode(node, screenSize);
    let gRatio = parseFloat(getNodeRootStyleAttributeValue(node, screenSize, gridAttributes.gridRatio, "1"));
    let gapX =  parseFloat(getNodeRootStyleAttributeValue(node, screenSize, gridAttributes.gridGapX, "0"));
    let gapY = parseFloat(getNodeRootStyleAttributeValue(node, screenSize, gridAttributes.gridGapY, "0"));

    if(gapY > 75*gRatio){
        gapY = 75*gRatio;
    }

    return {
        colCount: gridColRow.columnCount,
        rowCount: gridColRow.rowCount,
        gapX:gapX,
        gapY:gapY,
        ratio:gRatio,
    }



}



function GetGridSVGURL(gridRenderData: GridRenderData) {
    let halfGapX = gridRenderData.gapX / 2;
    let halfGapY = (gridRenderData.gapY / 2) / (gridRenderData.ratio||1);
    if (halfGapX > 50) {
        halfGapX = 50;
    }
    else if (halfGapX < 2) {
        halfGapX = 2;
    }

    if (halfGapY > 50) {
        halfGapY = 50;
    }
    else if (halfGapY < 2 / (gridRenderData.ratio||1)) {
        halfGapY = 2 /(gridRenderData.ratio||1);

    }


    let rectSizeX = 100 - halfGapX * 2;
    let rectSizeY = 100 - halfGapY * 2;

    return `url('data:image/svg+xml,<svg  xmlns="http://www.w3.org/2000/svg"  width="100" height="100"><rect width="${rectSizeX}%" x="${halfGapX}%" y="${halfGapY}%" height="${rectSizeY}%" rx="10" ry="10" fill="%23ffffff"/> </svg>')`


}

export const girdPreviewOpaticy = ".1";
//Returns a style object that has a grid background in the format of an SVG
function GridBGPreviewStyle(gridRenderData: GridRenderData, forceOpacity = false) {

    let gridSVGURL = GetGridSVGURL(gridRenderData);
    let style = {
        backgroundImage: gridSVGURL,
        backgroundColor: "black",
        left: 0,//gridRenderData.gap/2+"px",
        top: 0,//gridRenderData.gap/2+"px",
        width: "100%",// `calc(100% - ${gridRenderData.gap}px)`,
        height: "100%",// `calc(100% - ${gridRenderData.gap}px)`,

        pointerEvents: "none",
        backgroundSize: `${100 / gridRenderData.colCount}% ${100 / gridRenderData.rowCount}%`,
    } as any

    if (forceOpacity) {
        style.opacity = girdPreviewOpaticy;
    }

    return style;


}

const showGridShadow = true;
const showCenterLines = true;

export function RenderGrid({ node, screenSize, children, showOverlay, forceOverlay, isEditor }: { isEditor: boolean, node: LayoutNode, screenSize: ScreenSize, showOverlay: boolean, children?: JSX.Element, forceOverlay?: boolean }) {

    const gridRenderData = GetGridRenderData(node, screenSize);
    //
    const styling = GetGridStyling(node, screenSize);
    // let raito = gridRenderData.rowCount / gridRenderData.colCount ;

    // let XGapPerc = gridRenderData.gap / Math.max(gridRenderData.colCount + 1, 1);
    // let YGapPerc = (XGapPerc / raito) / (gridRenderData.ratio||1);

    // const ratio = (gridRenderData.rowCount / gridRenderData.colCount) * 100;

    return <EditorOnlyGridContainer isEditor={isEditor} paddingBottom={styling.paddingBottom}>

        {showOverlay && <div className="w-full h-full grid-preview relative"
            style={{
                position: "absolute",
                gridTemplateColumns: styling.grid.gridTemplateColumns,
                gridTemplateRows: styling.grid.gridTemplateRows,

                display: "grid",
                ...GridBGPreviewStyle(gridRenderData, forceOverlay)
            }}>
            {showGridShadow && <>
                {node.children.map((child, index) => {
                    let area = getNodeRootStyleAttributeValue(child, screenSize, gridAtt, "1/1/6/6");
                    return <div key={index} style={{ gridArea: area, width: "100%", height: "100%", pointerEvents: "none", background: "black", opacity: ".66", borderRadius: "6px" }}  ></div>


                })


                }
            </>
            }


        </div>

        }
        {showOverlay&&showCenterLines && <>
            <div className="grid-guide-lines" style={forceOverlay ? { opacity: "1" } : {}}>
                <div className="guide-line horizontal" style={{ position: "absolute", top: "0px", left: "50%", width: "0", height: "100%", pointerEvents: "none", outline: "1px dashed var(--outline-primary)" }}>

                </div>
                <div className="guide-line vertical" style={{ position: "absolute", top: "50%", left: "0", width: "100%", height: "0", pointerEvents: "none", outline: "1px dashed var(--outline-primary)" }}>

                </div>
            </div>
        </>

        }



        <div className="inner-grid" style={(isEditor) ? {


            columnGap: styling.grid.columnGap,
            rowGap: styling.grid.rowGap,

            top:styling.grid.top, left: styling.grid.left,
            width:styling.grid.width,
            height:styling.grid.height,
            gridTemplateColumns: `repeat(${gridRenderData.colCount},1fr)`,
            gridTemplateRows: `repeat(${gridRenderData.rowCount},1fr)`,

        } : {}}>

            {children}

        </div>

    </EditorOnlyGridContainer>

}

export function GetGridStyling(node: LayoutNode, screenSize: ScreenSize) {
    const gridRenderData = GetGridRenderData(node, screenSize);

    let raito = gridRenderData.rowCount / gridRenderData.colCount;
    // a "gap" is up to 50% of a cell size
    let XGapPerc = gridRenderData.gapX / Math.max(gridRenderData.colCount + 1, 1);
    let YGapPerc = ((gridRenderData.gapY / Math.max(gridRenderData.colCount + 1, 1)) / raito) / (gridRenderData.ratio||1);
    const ratio = (gridRenderData.rowCount / gridRenderData.colCount) * 100;

    return {

        paddingBottom: `${ratio*gridRenderData.ratio}%`,
        grid: {
            columnGap: XGapPerc + "%",
            rowGap: YGapPerc + "%",
            top: YGapPerc / 2 + "%", left: XGapPerc / 2 + "%",
            width: 100 - XGapPerc + "%",
            height: 100 - YGapPerc + "%",
            gridTemplateColumns: `repeat(${gridRenderData.colCount},1fr)`,
            gridTemplateRows: `repeat(${gridRenderData.rowCount},1fr)`,
        }
    }
}

export function GetGridStylingString(node: LayoutNode, screenSize: ScreenSize, prefix: string = "") {
    const data = GetGridStyling(node, screenSize);
    const gridStyling = data.grid;
    const paddingBottom = data.paddingBottom;
    let str =
        `
    ${prefix} .grid-container{
    padding-bottom:${paddingBottom};
    }
    ${prefix} .inner-grid{
    top:${gridStyling.top};
    left:${gridStyling.left};
    width:${gridStyling.width};
    height:${gridStyling.height};
    grid-template-columns:${gridStyling.gridTemplateColumns};
    grid-template-rows:${gridStyling.gridTemplateRows};
    row-gap:${gridStyling.rowGap};
    column-gap:${gridStyling.columnGap};
    }`;

    return str;
}



function EditorOnlyGridContainer({ children, paddingBottom, isEditor }: { isEditor: boolean, children: any, paddingBottom?: string }) {

    if (isEditor)
        return <div className="grid-container" style={{ paddingBottom: paddingBottom ?? "100%" }}>
            {children}
        </div>

    else
        return <div className="grid-container">{children}</div>
}

export function IsNodeInGrid(node: LayoutNode): boolean {
    if (!node) {
        return false;
    }
    if (node.parent && node.parent.typename == wBComponentTypeNames.grid) {
        return true;
    }
    return false;
}

export function HandleGridAreaResize(nodeDom: HTMLElement, node: LayoutNode, gridNode: LayoutNode, gridDom: HTMLElement, resizeType: ResizeType, screenSize: ScreenSize, mouseX: number, mouseY: number, otherSelections: { layout: LayoutNode, dom: HTMLElement }[]) {

    let others = otherSelections.filter((d) => d.layout.id != node.id && d.layout.parent?.id == gridNode.id);

    let area = GetGridAreaDataFromNode(node, screenSize);

    let gridData = GetGridRenderData(gridNode, screenSize);
    let bounds = gridDom.getBoundingClientRect();

    let cellWidth = bounds.width / gridData.colCount;
    let cellHeight = bounds.height / gridData.rowCount;
    let xPoint = Math.round((mouseX - bounds.x) / cellWidth) + 1;
    let yPoint = Math.round((mouseY - bounds.y) / cellHeight) + 1;

    let right = resizeType == ResizeType.Right || resizeType == ResizeType.TopRight || resizeType == ResizeType.BottomRight;
    let left = resizeType == ResizeType.Left || resizeType == ResizeType.TopLeft || resizeType == ResizeType.BottomLeft;
    let up = resizeType == ResizeType.Top || resizeType == ResizeType.TopLeft || resizeType == ResizeType.TopRight;
    let down = resizeType == ResizeType.Bottom || resizeType == ResizeType.BottomLeft || resizeType == ResizeType.BottomRight;

    let leftDif = 0;
    let rightDif = 0;
    let upDif = 0;
    let downDif = 0;
    let hasChanged = false;
    if (right) {
        if (xPoint < area.xStart + 1)
            xPoint = area.xStart + 1;
        if (xPoint > gridData.colCount + 1)
            xPoint = gridData.colCount + 1;
        rightDif = xPoint - area.xEnd;
        area.xEnd = xPoint;
    }
    if (left) {
        if (xPoint > area.xEnd - 1)
            xPoint = area.xEnd - 1;
        if (xPoint < 1)
            xPoint = 1;

        leftDif = xPoint - area.xStart;
        area.xStart = xPoint;
    }
    if (up) {
        if (yPoint > area.yEnd - 1)
            yPoint = area.yEnd - 1;
        if (yPoint < 1)
            yPoint = 1;

        upDif = yPoint - area.yStart;
        area.yStart = yPoint;
    }
    if (down) {
        if (yPoint < area.yStart + 1)
            yPoint = area.yStart + 1;
        if (yPoint > gridData.rowCount + 1)
            yPoint = gridData.rowCount + 1;

        downDif = yPoint - area.yEnd;
        area.yEnd = yPoint;
    }

    for (let i = 0; i < others.length; i++) {
        let other = others[i];
        let otherArea = GetGridAreaDataFromNode(other.layout, screenSize);
        otherArea.xStart += leftDif;
        otherArea.xEnd += rightDif;
        otherArea.yStart += upDif;
        otherArea.yEnd += downDif;

        if (otherArea.xStart < 1)
            otherArea.xStart = 1;
        if (otherArea.xEnd > gridData.colCount + 1)
            otherArea.xEnd = gridData.colCount + 1;
        if (otherArea.yStart < 1)
            otherArea.yStart = 1;
        if (otherArea.yEnd > gridData.rowCount + 1)
            otherArea.yEnd = gridData.rowCount + 1;

        setNodeStyleAttributeValue(other.layout, screenSize, gridAtt, `${Math.max(otherArea.yStart, 1)}/${Math.max(otherArea.xStart, 1)}/${otherArea.yEnd}/${otherArea.xEnd}`);
        other.dom.style.gridArea = `${otherArea.yStart}/${otherArea.xStart}/${otherArea.yEnd}/${otherArea.xEnd}`;
    }


    const resizeStr = `${area.yStart}/${area.xStart}/${area.yEnd}/${area.xEnd}`;
    if (leftDif != 0 || rightDif != 0 || upDif != 0 || downDif != 0) {
        setNodeStyleAttributeValue(node, screenSize, gridAtt, resizeStr);
        nodeDom.style.gridArea = resizeStr;
        if ((window as any).updateGridAreaUI) {
            (window as any).updateGridAreaUI(resizeStr);
        }
    }


}

export function ClampAllGridAreaBounds(gridNode: LayoutNode) {

    ClampAllGridAreaBoundsForScreen(gridNode, ScreenSize.Desktop);
    ClampAllGridAreaBoundsForScreen(gridNode, ScreenSize.Tablet);
    ClampAllGridAreaBoundsForScreen(gridNode, ScreenSize.Mobile);

}

 function ClampNodeInGridRender(child:LayoutNode, gridData: GridRenderData, screenSIze: ScreenSize){
    let area = GetGridAreaDataFromNode(child, screenSIze);
    let hasChanged = false;

    if (area.xStart < 1) {
        area.xStart = 1;
        hasChanged = true;
    }
    if (area.xEnd > gridData.colCount + 1) {
        area.xEnd = gridData.colCount + 1;
        hasChanged = true;
    }
    if (area.yStart < 1) {
        area.yStart = 1;
        hasChanged = true;
    }
    if (area.yEnd > gridData.rowCount + 1) {
        area.yEnd = gridData.rowCount + 1;
        hasChanged = true;
    }

    if (hasChanged) {

        if (area.xEnd - area.xStart < 1) {
            area.xEnd = area.xStart + 1;

            if (area.xEnd > gridData.colCount + 1) {
                area.xEnd = gridData.colCount + 1;
                area.xStart = area.xEnd - 1;
            }
        }
        if (area.yEnd - area.yStart < 1) {
            area.yEnd = area.yStart + 1;
            if (area.yEnd > gridData.rowCount + 1) {
                area.yEnd = gridData.rowCount + 1;
                area.yStart = area.yEnd - 1;
            }
        }



    }

    if (hasChanged) {
        setNodeStyleAttributeValue(child, screenSIze, gridAtt, `${area.yStart}/${area.xStart}/${area.yEnd}/${area.xEnd}`);
        child.forceUpdate && child.forceUpdate();
    }
}

export function ClampNodeInGrid(node:LayoutNode,grid:LayoutNode, screenSIze: ScreenSize){
    let gridData = GetGridRenderData(grid, screenSIze);
    ClampNodeInGridRender(node, gridData, screenSIze);

}

function ClampAllGridAreaBoundsForScreen(gridNode: LayoutNode, screenSIze: ScreenSize) {
    let gridData = GetGridRenderData(gridNode, screenSIze);
    for (let i = 0; i < gridNode.children.length; i++) {
        let child = gridNode.children[i];
        ClampNodeInGridRender(child, gridData, screenSIze);

    }

}


let debounceRef: any = null; // just store the debounce ref statically



export function HandleGridTemplateResize(wbManager: WebDesigner, gridDom: HTMLElement, gridNode: LayoutNode, screenSize: ScreenSize, mouseY: number, resizeType: ResizeType, mouseDownY: number, origRowCount: number) {

    let dir = (resizeType == ResizeType.Bottom) ? 1 : -1;

    let bounds = gridDom.getBoundingClientRect();
    let data = GetGridRenderData(gridNode, screenSize);
    let cellHeight = bounds.height / data.rowCount;
    let others: LayoutNode[] = [];


    if (gridNode.parent) {
        others = gridNode.parent.children.filter((d) => {
            if (d.id === gridNode.id || d.typename != wBComponentTypeNames.grid)
                return false;

            let testData = GetGridRenderData(d, screenSize);
            return testData.rowCount == data.rowCount && testData.colCount == data.colCount;


        });

    }


    let relativeY = (mouseY - mouseDownY) * dir;
    let newRowCount = Math.round(relativeY / cellHeight) + origRowCount;


    if (newRowCount < 1) {
        newRowCount = 1;
    }

    if (debounceRef) {
        clearTimeout(debounceRef);
    }
    if (getNodeComponentAttributeValue(gridNode, gridAttributes.forcePreview, "") == "") {
        setNodeComponentAttributeValue(gridNode, gridAttributes.forcePreview, `true`);
        gridNode.forceUpdate && gridNode.forceUpdate();
    }

    debounceRef = setTimeout(() => {
        setNodeComponentAttributeValue(gridNode, gridAttributes.forcePreview, "");
        gridNode.forceUpdate && gridNode.forceUpdate();
    }, 666);

    if (newRowCount != data.rowCount) {

        let inputDOm = document.querySelector(".row-count-input");
        if (inputDOm) {
            (inputDOm as HTMLInputElement).value = newRowCount.toString();
        }

        let newRowStr = `repeat(${newRowCount},1fr)`;

        setNodeStyleAttributeValue(gridNode, screenSize, gridAttributes.gridTemplateRows, newRowStr);
        if (gridNode.forceUpdate) {
            gridNode.forceUpdate();

        }
        else {
            console.warn("Grid node not found in DOM, updating entire canvas", gridNode.id);
            wbManager.forceUpdate();
        }

        for (let i = 0; i < others.length; i++) {
            let other = others[i];
            setNodeStyleAttributeValue(other, screenSize, gridAttributes.gridTemplateRows, newRowStr);
            other.forceUpdate && other.forceUpdate();
        }

        ClampAllGridAreaBounds(gridNode);

    }


}

export function ConvertGridLayoutToMobile(gridNode: LayoutNode, fromSize: ScreenSize = ScreenSize.Tablet) {

    let gridData = GetGridRenderData(gridNode, fromSize);
    let midHeight = gridData.rowCount;

    gridData.rowCount = gridData.rowCount * 2;

    gridData.colCount = Math.round(gridData.colCount / 2);

    setNodeStyleAttributeValue(gridNode, ScreenSize.Mobile, gridAttributes.gridTemplateRows, `repeat(${gridData.rowCount},1fr)`);
    setNodeStyleAttributeValue(gridNode, ScreenSize.Mobile, gridAttributes.gridTemplateColumns, `repeat(${gridData.colCount},1fr)`);

    for (let i = 0; i < gridNode.children.length; i++) {
        let child = gridNode.children[i];
        let area = GetGridAreaDataFromNode(child, fromSize);
        let center = Math.round((area.xStart + area.xEnd) / 2);
        if (center - 2 < gridData.colCount && center + 2 > gridData.colCount) {


        }

        else if (center > gridData.colCount) {
            area.yStart += midHeight;
            area.yEnd += midHeight;
            area.xStart -= gridData.colCount;
            area.xEnd -= gridData.colCount;

            setNodeStyleAttributeValue(child, ScreenSize.Mobile, gridAttributes.gridArea, `${area.yStart}/${area.xStart}/${area.yEnd}/${area.xEnd}`);
        }

    }

    ClampAllGridAreaBoundsForScreen(gridNode, ScreenSize.Mobile);

}


export function IsNodeCenteredInGrid(node: LayoutNode, grid: LayoutNode) {
    let area = GetGridAreaDataFromNode(node, ScreenSize.Desktop);
    let gridData = GetGridRenderData(grid, ScreenSize.Desktop);
    return IsAreaCenteredInGrid(area, gridData);

}

export function IsAreaCenteredInGrid(area:GridAreaData, gridData: GridRenderData){

    let returnVals = {horizontal:false,vertical:false};
    let centerX = Math.round((area.xStart + area.xEnd) / 2);
    let centerY = Math.round((area.yStart + area.yEnd) / 2);
    if(centerX == Math.round(gridData.colCount/2)){
        returnVals.horizontal = true;
    }
    if(centerY == Math.round(gridData.rowCount/2)){
        returnVals.vertical = true;
    }
    return returnVals;
}